import type { Person, PersonRole } from './source.ts';

/** The most elevated role wins: `owner`, then `admin`, then any other (the
 *  first Boule listed). Decision on this PR; the product has no wider ranking. */
function rank(role: PersonRole): number {
  return role.key === 'owner' ? 2 : role.key === 'admin' ? 1 : 0;
}

/** The role's display name to show next to a person, or `null` when Boule
 *  returned none (the field is absent, or the list is empty). */
export function roleLabel(person: Pick<Person, 'roles'>): string | null {
  let best: PersonRole | null = null;
  for (const role of person.roles ?? []) {
    if (!best || rank(role) > rank(best)) best = role;
  }
  return best?.name ?? null;
}
